import * as Scrivito from "scrivito";
import defaultFormInputAttributes from "../../_defaultFormAttributes";

const ReceiverEmailInputWidget = Scrivito.provideWidgetClass(
  "ReceiverEmailInputWidget",
  {
    attributes: {
      ...defaultFormInputAttributes,
      propertyName: "string",
      placeholder: "string",
    },
    onlyInside: "FormPageWidget",
  }
);

export default ReceiverEmailInputWidget;
